<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Office Job Schedulers &nbsp;
          <add-button
            link="/planned-maintenance/office-job-schedulers/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">Office Job Schedulers</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body row">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
          <div class="col-md-4">
            <div style="float: right">
              <a
                href="#"
                class="btn btn-primary"
                v-if="ExportOfficeJobSchedulers.length == 0"
                @click="exportToExcel"
              >
                <span v-if="isExcelloading">
                  <div class="d-flex align-items-center">
                    <strong>Generating Excel</strong>
                    &nbsp;
                    <div
                      class="
                        spinner-border
                        text-light
                        spinner-border-sm
                        ms-auto
                      "
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                </span>
                <span v-else>Generate Excel</span>
              </a>
              <download-excel
                :title="title"
                v-else
                class="btn btn-success"
                :data="office_job_schedulers_excel"
                :fields="excel_fields"
                worksheet="Office Job Schedulers"
                name="Office Job Scheduler.xls"
                >Download Excel
              </download-excel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Job Title</th>
                    <th>Job Done By</th>
                    <th>Expented Completion Date</th>
                    <th>Completed Date</th>
                    <th>Job Description</th>
                    <th>Job Status</th>
                    <th>Job Done Comments</th>
                    <th>Attachment</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="10"
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="OfficeJobSchedulers.length == 0">
                    <td colspan="10" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(OfficeJobScheduler, at) in OfficeJobSchedulers"
                    :key="`OfficeJobScheduler${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ OfficeJobScheduler.job_title }}</td>
                    <td>
                      {{
                        OfficeJobScheduler.job_done_by
                          ? OfficeJobScheduler.job_done_by.first_name
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        OfficeJobScheduler
                          ? OfficeJobScheduler.expected_completion_date
                          : "" | ddmmyyyy
                      }}
                    </td>
                    <td>{{ OfficeJobScheduler.completed_date | ddmmyyyy }}</td>
                    <td>{{ OfficeJobScheduler.job_description }}</td>
                    <td>{{ OfficeJobScheduler.job_status }}</td>
                    <td>{{ OfficeJobScheduler.job_done_comments }}</td>
                    <td>
                      <img
                        v-if="OfficeJobScheduler.attachment"
                        :src="`${mediaUrl + OfficeJobScheduler.attachment}`"
                        alt=""
                        srcset=""
                      />
                      <span v-else></span>
                    </td>
                    <td>
                      <div>
                        <router-link
                          :to="`/planned-maintenance/office-job-schedulers/${OfficeJobScheduler.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(OfficeJobScheduler.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "OfficeJobScheduler",
  data() {
    return {
      OfficeJobSchedulers: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      office_job_schedulers_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        "Job Title": "job_title",
        "Job Done By": "job_done_by",
        "Expented Completion Date": "expected_completion_date",
        "Completed Date": "completed_date",
        "Job Description": "job_description",
        "Job Status": "job_status",
        "Job Done Comments": "job_done_comments",
      },
      ExportOfficeJobSchedulers: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let OfficeJobSchedulers = await axios.get(
        `/office_job_schedulers?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.OfficeJobSchedulers = OfficeJobSchedulers.data.data;
      this.count = OfficeJobSchedulers.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let OfficeJobSchedulers = await axios.get(
        `/office_job_schedulers?search=${this.searchData}`
      );
      this.OfficeJobSchedulers = OfficeJobSchedulers.data.data;
      this.count = OfficeJobSchedulers.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Office Job Scheduler Data";
      this.office_job_schedulers_excel = [];
      let ExportOfficeJobSchedulers = [];
      ExportOfficeJobSchedulers = await axios.get(`/office_job_schedulers`);
      this.ExportOfficeJobSchedulers = ExportOfficeJobSchedulers.data.data;
      let sr_no = 1;
      this.ExportOfficeJobSchedulers.forEach((OfficeJobScheduler) => {
        this.office_job_schedulers_excel.push({
          sr_no: sr_no,
          job_title: OfficeJobScheduler.job_title
            ? OfficeJobScheduler.job_title
            : "",
          job_done_by_id: OfficeJobScheduler.job_done_by
            ? OfficeJobScheduler.job_done_by.first_name
            : "",
          expected_completion_date: OfficeJobScheduler.expected_completion_date
            ? OfficeJobScheduler.expected_completion_date
            : "",
          completed_date: OfficeJobScheduler.completed_date
            ? OfficeJobScheduler.completed_date
            : "",
          job_description: OfficeJobScheduler.job_description
            ? OfficeJobScheduler.job_description
            : "",
          job_status: OfficeJobScheduler.job_status
            ? OfficeJobScheduler.job_status
            : "",
          job_done_comments: OfficeJobScheduler.job_done_comments
            ? OfficeJobScheduler.job_done_comments
            : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=office_job_schedulers`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
